// extracted by mini-css-extract-plugin
module.exports = {"logoutButton":"courses-module--logoutButton--1gklA","userName":"courses-module--userName--2a-Ci","root":"courses-module--root--3rkzW","media":"courses-module--media--2G9CT"};